import React, { useRef, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { Header } from '../../components/header';
import useStyles from './styles';
import { VIMSSearchBar } from '../../components/search-bar/vims-search';
import { AppState } from '../../store';
import TimeRange from '../../components/time-range';
import TransactionsTable from '../../components/transactions/transactions-table';
import DeviceDetailQuickLook from '../../components/transactions/device-detail-quick-look';
import ActiveFilters from '../../components/transactions/active-filters';
import { User, FilterHeader, Time, Help, Search } from '../../components/header/components';
import DeviceLabel from '../../components/device-label';
import ReloadIcon from '../../assets/icons/reload-icon';
import { useMountEffect } from '../../globals/hooks/use-mount-effect';
import theme from '../../globals/theme';
import ColumnSortVisibility from '../../components/virtualized-table/components/column-sort-visibility';
import {
  vimsTransactionsHeadCells,
  sortableAccessors,
} from '../../components/transactions/transactions-table/head-cells';
import { uniqueId } from '../../globals/utils';
import { setSelectedEntityFromDeviceOrTelematicsId } from '../../store/search/actions';
import DealerTransactionsTable from '../../components/transactions/dealer-transactions-table/index';

const VimsTransactionsInfiniteScroll = () => {
  const history = useHistory();
  const { telematicsAssetId } = useParams<{ telematicsAssetId: string }>();
  const { deviceId } = useParams<{ deviceId: string }>();
  const dispatch = useDispatch();
  const classes = useStyles();
  const recordCount = useSelector((state: AppState) => state.transactions.count);
  const selectedVIMSEntity = useSelector((state: AppState) => state.search.selectedVIMSEntity);
  const selectedEntity = useSelector((state: AppState) => state.search.selectedEntity);
  const table: any = useRef<HTMLElement>(null);
  const [columnVisibility, setColumnVisibility] = useState([]);
  const [columnOrder, setColumnOrder] = useState([]);
  const [resetTableString, setResetTableString] = useState(uniqueId());
  const storageString = 'vims-transaction-table';
  const savedHidden = window.localStorage.getItem(`${storageString}-hidden-columns`);
  const parameters: URLSearchParams = new URLSearchParams(history.location.search);
  const dealerCode: any = parameters.get('dealerCode') !== null ? parameters.get('dealerCode') : '';
  useMountEffect(() => {
    if (telematicsAssetId && dealerCode.length === 0) dispatch(setSelectedEntityFromDeviceOrTelematicsId(telematicsAssetId));
    const savedHiddenItems = savedHidden && savedHidden !== 'null' ? JSON.parse(savedHidden) : [];
    if (!savedHiddenItems.includes('fileSize')) {
      savedHiddenItems.push('fileSize');
    }
    window.localStorage.setItem(
      `${storageString}-hidden-columns`,
      JSON.stringify(savedHiddenItems),
    );
  });

  const columnController = {
    storageString,
    setColumnVisibility,
    columnVisibility,
    setColumnOrder,
    columnOrder,
    headerColumns: vimsTransactionsHeadCells,
    sortableAccessors,
    reloadTable: () => setResetTableString(uniqueId),
  };
  return (
    <>
      <Header
        title="VIMS Transactions"
        headerComponents={
          selectedVIMSEntity || dealerCode.length > 0
            ? [<Help userLink="/SitePages/VIMS-Transactions-Manual.aspx" />, <Search page="vims-transactions" />, <FilterHeader />, <Time />, <User />]
            : [<Help  userLink='/SitePages/Search-Page-Manual.aspx'/>, <Time suppressPopover />, <User />]
        }
      />
      { !selectedVIMSEntity ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="calc(100vh - 5vh - 64px)"
          paddingBottom="5vh"
        >
          <VIMSSearchBar page="vims-transactions" />
        </Box>
      ) : (
        <Box className={classes.scrollBox}>
          <Box
            className={classes.margin}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            flexWrap="wrap"
          >
            <Box display="flex" alignItems="center">
              <DeviceLabel />
              <Box flexGrow={1} display="flex" alignItems="center">
                {/* {dealerCode.length === 0 && <DeviceDetailQuickLook />} */}
                <Tooltip title="Refresh Data" enterDelay={600}>
                  <span>
                    <IconButton
                      onClick={() => setResetTableString(uniqueId())}
                      id="reloadButton"
                      size="large"
                    >
                      <ReloadIcon stroke={`${theme.palette.grey[600]}`} />
                    </IconButton>
                  </span>
                </Tooltip>
                  <ActiveFilters vimsDataFilter={dealerCode && dealerCode.length > 0} page='vims-transaction' />
              </Box>
            </Box>
            <Box display="flex" alignItems="center">
              <Box pr={2}>
                {!!recordCount && recordCount > 0 && (
                  <Typography className={classes.count}>
                    {`${recordCount} Record${recordCount > 1 ? 's' : ''}`}
                  </Typography>
                )}
              </Box>
              <TimeRange />
              <ColumnSortVisibility {...columnController} />
            </Box>
          </Box>
          <div className={classes.tableContainer} ref={table}>

            <TransactionsTable
              headCells={vimsTransactionsHeadCells}
              columnOrder={['expander', ...columnOrder]}
              columnVisibility={columnVisibility}
              resetTableString={resetTableString}
              tableContainer={table}
              storageString={storageString}
              id="transactionsTable"
            />
          </div>
        </Box>
      )}
    </>
  );
};
export default VimsTransactionsInfiniteScroll;
